import { Dropdown, useTranslator } from "@sia/style-guide";
import { useCallback, useContext, useEffect } from "react";
import { WizarContext, singleSectionInfoActionCreator } from "contexts/WizardContext";
import GlobalContext from "contexts/GlobalContext";
import webPlatformAdapter from "common/Adapters/WebPlatformAdapter/WebPlatformAdapter";
import { initialWizardFormState } from "contexts/WizardContext";

const SectionInfo = ({ errors, setErrors }) => {
  const translate = useTranslator();
  const { state, dispatch } = useContext(WizarContext);
  let sectionInfo = state.single.sectionInfo;
  let sectionsInfoErrors = errors.single.sectionInfo;
  let changState = useCallback((payload) => dispatch(singleSectionInfoActionCreator(payload)), [dispatch]);
  const professionGroup = "Berufsgruppe Architektur";
  const resetInputFieldError = (property) => {
    if (errors.single.sectionInfo[property]) {
      setErrors((errorsState) => ({
        ...errorsState,
        single: {
          ...errorsState.single,
          sectionInfo: { ...errorsState.single.sectionInfo, [property]: "" },
        },
      }));
    }
  };

  const { user } = useContext(GlobalContext);
  const userId = user.siaId;

  const setUserSession = (obj) => {
    webPlatformAdapter.getWizardSession(userId, (data) => {
      const updatedSession = { ...data, sectionInfo: { ...data.sectionInfo, ...obj } };
      webPlatformAdapter.setWizardSession(userId, { ...updatedSession });
    });
  };

  useEffect(() => {
    if (userId) {
      webPlatformAdapter.getWizardSession(userId, (data) => {
        const defaultSectionInfo = { ...initialWizardFormState.single.sectionInfo };
        const { sectionInfo } = data;
        const { price } = sectionInfo || defaultSectionInfo;
        changState({
          price,
        });
      });
    }
  }, [userId, changState]);

  const langauges = [
    { label: "DE", id: "de" },
    { label: "FR", id: "fr" },
    { label: "IT", id: "it" },
    { label: "EN", id: "en" },
  ];

  return (
    <div className="section-info-page">
      <p>{translate("wizard.form.single.sections.info")}</p>
      <Dropdown
        id={"otherAddresses-page-contact"}
        label={translate("wizard.form.single.sections.price.example")}
        items={langauges}
        value={sectionInfo.price}
        required={true}
        onChange={(event, value) => {
          resetInputFieldError("price");
          changState({ price: value });
          setUserSession({ price: value });
        }}
        placeholder={translate("wizard.form.single.placeholder")}
        invalid={sectionsInfoErrors.price}
        invalidText={sectionsInfoErrors.price}
      />
      <p>{translate("wizard.form.single.sections.professional-group.info")}</p>
      <p className="sia-margin-03-top sia-text-03">{professionGroup}</p>
    </div>
  );
};

export default SectionInfo;
